"use client";

import { useIsMobile } from "@/hooks/use-mobile";
import { useTheme } from "next-themes";
import { DropdownMenuSeparator } from "../ui/dropdown-menu";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { is } from "zod/v4/locales";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
  altText?: string;
}

export default function Logo({ className, size = "lg", altText }: LogoProps) {
  const { resolvedTheme } = useTheme();
  const isMobile = useIsMobile();
  const [currentIndex, setCurrentIndex] = useState(0);

  const jobTitles = [
    "Full-Stack Developer",
    "UI/UX Designer",
    "Tech Enthusiast",
    "Software Engineer",

    "Lifelong Learner",
    "Problem Solver",
    "Getaway Driver",
    "'Ctrl + Z' Expert",
    "Earth Dweller",
    "Open Source Contributor",
    "Code Artisan",
    "Ideas Man",
    "Chess Player",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % jobTitles.length);
    }, 2500); // Change every 2.5 seconds

    return () => clearInterval(interval);
  }, [jobTitles.length]);

  return (
    <div
      className={cn(
        "grid border rounded-lg transition-all place-items-center p-2 hover:border-primary cursor-pointer group hover:text-primary/70",
        isMobile ? "w-40" : "w-44",
        className,
      )}
    >
      <div className="w-full text-foreground/80 text-xl text-center font-semibold group-hover:text-primary">
        Brian Otieno
      </div>
      {/* separator */}
      <DropdownMenuSeparator className="my-1 w-3/4 bg-primary/40 group-hover:bg-primary" />
      {/* Job title carousel */}
      {altText ? (
        <div className="items-center group-hover:text-primary">
          <span className="text-xs">{altText}</span>
        </div>
      ) : (
        <div className="relative h-6 w-full overflow-hidden group-hover:text-primary">
          <div className="absolute inset-0 flex items-center justify-center">
            {jobTitles.map((title, index) => (
              <span
                key={title}
                className={`absolute text-sm text-foreground/60 transition-all duration-500 ease-in-out ${
                  index === currentIndex
                    ? "opacity-100 translate-y-0"
                    : index < currentIndex
                      ? "opacity-0 -translate-y-full"
                      : "opacity-0 translate-y-full"
                }`}
              >
                {title}
              </span>
            ))}{" "}
          </div>
        </div>
      )}
    </div>
  );
}
